var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/videoIcon.9f709c02.png","uri@3x": __webpack_public_path__ + "static/media/videoIcon.8ae2164c.png","uri@2x": __webpack_public_path__ + "static/media/videoIcon.9f709c02.png",
    width: 44,
    height: 32
});